import React from 'react';
import ReactDOMServer from 'react-dom/server';

// Components
import Snippet from '../../../common/Snippet';

const Negative = class Negative extends React.Component {
  example = [
    <button className="btn btn--negative" key="1">
      Button
    </button>,

    <button className="btn btn--negative" key="2">
      <svg aria-hidden="true" className="icon icon-times" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M3.97833 2.12217L2.12217 3.97833L6.14384 8L2.12217 12.0217L3.97833 13.8778L8 9.85616L12.0217 13.8778L13.8778 12.0217L9.85616 8L13.8778 3.97833L12.0217 2.12217L8 6.14384L3.97833 2.12217Z"/></svg>

      Button
    </button>,

    <button className="btn btn--outline btn--negative" key="3">
      Button
    </button>,

    <button className="btn btn--outline btn--negative" key="4">
      <svg aria-hidden="true" className="icon icon-times" width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M3.97833 2.12217L2.12217 3.97833L6.14384 8L2.12217 12.0217L3.97833 13.8778L8 9.85616L12.0217 13.8778L13.8778 12.0217L9.85616 8L13.8778 3.97833L12.0217 2.12217L8 6.14384L3.97833 2.12217Z"/></svg>

      Button
    </button>
  ]

  render() {
    const { translation } = this.props;

    return (
      <section className="page__section">
        <h3>{translation.examples.negative}</h3>

        <article
          className="example"
        >
          {this.example}
        </article>

        <Snippet
          {...this.props}
          name="primary"
          code={ReactDOMServer.renderToStaticMarkup(this.example)}
        />
      </section>
    )
  }
}

export default Negative;
